angular.module('rentalListingModule').component('rentalListingLimitMessage', {
	templateUrl: 'rentalListingLimitMessage/rentalListingLimitMessage.html',
	bindings: {
		isMobile: '<',
		myListingsUrl: '<',
		popupName: '<',
		limitListings: '<'
	},
	controller: ['$http', 'PubSub', function($http, PubSub) {
		// to stop displaying the abandoned message when the user close the popup
		PubSub.publish('cr-popup-success-message-' + this.popupName);
	}]
});
